import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {fieldView_template} from "../components/templates/fieldView_template";

declare var ko: any;
declare var page: any;

export class field_view extends vnModule_knockoutJS {

    protected fieldView: fieldView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Array<Element> {
        this.fieldView = new fieldView_template("fieldView", this.viewModel, this);
        return [this.fieldView.build()];
    }

    protected getModuleName(): string {
        return "field_view";
    }

    fillPage() {
        this.getFieldDataForView()
    }

    private getFieldDataForView() {

        this.loadingIn(this.fieldView.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/field/get/view/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetFieldDataForView;
        this.XHRHdl.execute();
    }

    private onGetFieldDataForView(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let field = responseParsed.data
                obj.fieldView.setFieldData(field);
            });

            obj.loadingOut(obj.fieldView.builtTemplate);
        }
    }

    protected onClickEditField(id){
        let brandId = this.getVnAppZone().app.params.idBrand
        page("/brand/" + brandId + "/newsletter/fields/edit/" + id + '/')
    }

    protected onClickCancel(){
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/newsletter/fields/")
    }
}


// WEBPACK FOOTER //
// ./js/modules/field_view.ts